"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.customModel.exceeded': 'Límite de modelos de IA personalizados alcanzado. Actualice su plan para entrenar más modelos.',
    'limits.customModel.limitReached': 'Límite de modelo personalizado: {limit} (actualizar para más)',
};
